// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DdlCMzcyBj0IhamaGjzl{flex-direction:column;gap:18px;display:flex}.Pg68lMFScMJ1Cw1JFOgM{flex-direction:column;display:flex}.IpbMS7oZtEElqy6O9Am4{cursor:pointer;align-items:center;gap:8px;height:32px;margin:0 8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `DdlCMzcyBj0IhamaGjzl`,
	"section": `Pg68lMFScMJ1Cw1JFOgM`,
	"wrapCheckbox": `IpbMS7oZtEElqy6O9Am4`
};
export default ___CSS_LOADER_EXPORT___;
